/*
    EmploymentPage (API)
    EmploymentPage関連のAPI
*/
import session from './session'
import excel   from './excel'
import file   from './file'

var uri = process.env.API_ENDPOINT

export default {
  postContents (content) {
    return session.post(uri + '/api/ep/post_content/', content)
  },
  postContentsRecruit (content, pages, layout) {
    return session.post(uri + '/api/ep/post_content_recruit/' + pages + '/' + layout + '/', content)
  },
  getContentsList (pages, isRecruitPage, userHash) {
    return session.get(uri + '/api/ep/get_contents/' + pages + '/' + isRecruitPage + '/' + userHash + '/')
  },
  getAllContentsId () {
    return session.get(uri + '/api/ep/get_all_contents_id/')
  },
  getContentsQuery (pages, isRecruitPage, query, userHash) {
    return session.get(uri + '/api/ep/get_contents_query/' + pages + '/' + isRecruitPage + '/' + query + '/' + userHash + '/')
  },
  getContentsSort (pages, isRecruitPage, sortflg, idx, query, userHash) {
    return session.get(uri + '/api/ep/get_contents_sort/' + pages + '/' + isRecruitPage + '/' + sortflg + '/' + idx + '/' + userHash + '/?q=' + query)
  },
  getContentsListPublic (pages) {
    return session.get(uri + '/api/ep/recruit_contents' + '?pages=' + pages)
  },
  getContentsSearch (search) {
    return session.get(uri + '/api/ep/recruit_contents/search' + '?q=' + search)
  },
  getContentsRecommend (cid) {
    return session.get(uri + '/api/ep/get_contents_recommend/' + cid + '/')
  },
  putContents (content, pages) {
    return session.put(uri + '/api/ep/put_content/' + pages + '/', content)
  },
  syncCountContents (company_id) {
    return session.get(uri + '/api/ep/sync_count/' + company_id + '/')
  },
  postContentImage (image) {
    return session.post(uri + '/api/ep/post_image/', image)
  },
  postMainContentImage (image) {
    return session.post(uri + '/api/ep/post_image_main/', image)
  },
  deleteContent (content) {
    return session.delete(uri + '/api/ep/delete_content/' + content.contents_id + '/')
  },
  postContentImport (data) {
    return session.post(uri + '/api/ep/post_import/', data)
  },
  getContentsApply () {
    return session.get(uri + '/api/ep/recruit_contents/apply')
  },
  getRootContent () {
    return session.get(uri + '/api/ep/get_root_content/')
  },
  postRootContent (content) {
    return session.post(uri + '/api/ep/post_root_content/', content)
  },
  putRootContent (content) {
    return session.put(uri + '/api/ep/put_root_content/', content)
  },
  deleteRootContent (id) {
    return session.delete(uri + '/api/ep/delete_root_content/' + id + '/')
  },
  excelImport (data) {
    return file.post(uri + '/api/ep/post_contents_excel/', {file: data})
  },
  excelExport () {
    var w = window.open(uri + '/api/ep/get_contents_excel/' + company_id + '/', '_blank')
    return false
  },
  excelExportAll (companyID, userHash) {
    var w = window.open(uri + '/api/ep/get_contents_excel_all/' + companyID + '/' + userHash + '/', '_blank')
    return false
  },
  getAllContentsList () {
    return session.get(uri + '/api/ep/get_all_contents_list/')
  },
  // 求人ページ変更履歴取得
  getEmploymentChangeHistory(contentID) {
    return session.get(uri + '/api/ep/employmentpage_change_history/' + contentID)
  },
  // 求人原稿タグ取得
  getEmploymentPageTag() {
    return session.get(uri + '/api/ep/get_employmentpage_tag/')
  },
  // 求人原稿タグ作成
  createEmploymentPageTag(createTagData) {
    return session.post(uri + '/api/ep/create_employmentpage_tag/', createTagData)
  },
  // 求人原稿タグ削除
  deleteEmploymentPageTag(tagID){
    return session.delete(uri + '/api/ep/delete_employmentpage_tag/' + tagID + '/')
  },
}



// WEBPACK FOOTER //
// ./src/api/employmentPage.js